// extracted by mini-css-extract-plugin
module.exports = {"font":"font_font__7HmV6","content":"font_content__DsQw-"};